import { render, staticRenderFns } from "./EmployerMatchNumberTiersSelect.vue?vue&type=template&id=f01e1c6a&"
import script from "./EmployerMatchNumberTiersSelect.vue?vue&type=script&lang=js&"
export * from "./EmployerMatchNumberTiersSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports